import { SiGithub } from "react-icons/si";
import { ButtonCardGit, Span } from "./style";

function ButtonCardGits() {
  return (
    <>
      <ButtonCardGit>
        <Span>
          <SiGithub />
        </Span>
      </ButtonCardGit>
    </>
  );
}
export default ButtonCardGits;
